import React, { useState, useEffect } from "react";
import ProjectPropOne from "./itemProp/ProjectPropOne";
import SectionTitle2 from "../../elements/section-title2/SectionTitle2";
import ProjectData from "../../data/project/ProjectData.json";
import SmartCardData from "../../data/project/SmartCardData.json";
import SmartTechCard from "./itemProp/SmartTechCard";

const ProjectOne = ({
  parentClass,
  colSize,
  columnGap,
  title,
  subtitle,
  isHomePage,
  isSmartTech,
}) => {
  const AllData = isSmartTech ? SmartCardData : ProjectData;

  const [paddingStyle, setPaddingStyle] = useState({});

  useEffect(() => {
    const updatePadding = () => {
      if (!isHomePage) {
        const isTabletOrBelow = window.innerWidth <= 991;
        setPaddingStyle({
          padding: isTabletOrBelow ? "0px 0px 0px" : "110px 0px 0px",
        });
      }
    };

    updatePadding();
    window.addEventListener("resize", updatePadding);
    return () => window.removeEventListener("resize", updatePadding);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div
        className={`section ${isHomePage ? "section-padding-2" : ""} ${
          parentClass ? parentClass : ""
        }`}
        style={!isHomePage ? paddingStyle : {}}
      >
        <div className="container">
          <SectionTitle2
            SectionTitle2
            subtitle={subtitle}
            title={title}
            textAlignment="heading-left mb--40"
            textColor=""
          />

          <div className={`row ${columnGap ? columnGap : "row-35"}`}>
            {AllData.slice(0, 8).map((data) => (
              <div className={colSize ? colSize : "col-md-6"} key={data.id}>
                {isSmartTech ? (
                  <SmartTechCard
                    projectStyle=""
                    portfolio={data}
                    isHomePage={isHomePage}
                  />
                ) : (
                  <ProjectPropOne
                    projectStyle=""
                    portfolio={data}
                    isHomePage={isHomePage}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectOne;
